<div class="mb-5">
  <app-revenue-overview />
</div>

<div class="grid grid-cols-1 fhd:grid-cols-[minmax(0,40%)_1fr] gap-6 px-4 lg:px-4 items-start min-w-0">
  <section class="order-2 fhd:order-1 min-w-0 rounded-2xl overflow-hidden bg-white/90 dark:bg-white/[0.06] border border-slate-900/10 dark:border-white/10 shadow-[0_12px_28px_rgba(2,6,23,0.08)] dark:shadow-[0_18px_40px_rgba(0,0,0,0.35)] flex flex-col min-h-0 lg:min-h-[560px]">
    <header class="flex items-start justify-between gap-3 p-3 border-b border-slate-900/10 dark:border-white/10 bg-white/35 dark:bg-white/[0.04] backdrop-blur-[10px]">
      <div class="min-w-0">
        <h2 class="m-0 text-[15px] font-black tracking-tight text-slate-900 dark:text-white">Meus últimos eventos</h2>
        <p class="mt-1.5 text-xs text-slate-600 dark:text-slate-300">Auditoria de ações recentes do usuário</p>
      </div>

      <app-button
        color="secondary"
        size="small"
        (click)="fetchEvents()"
        [disabled]="userEventsLoading"
        icon="refresh-cw"
      ></app-button>
    </header>

    <div class="flex-1 min-h-0 flex flex-col">
      @if (userEventsLoading) {
        <div class="flex justify-center items-center py-12">
          <app-loading size="large" color="primary"></app-loading>
        </div>
      }

      @if (error) {
        <app-alert [type]="'danger'">{{ error }}</app-alert>
      }

      @if (!userEventsLoading && !error) {
        <div class="relative flex-1 min-h-0 overflow-hidden p-3">
          <div>
            <app-audit-event-display
              [events]="events"
              [loading]="userEventsLoading">
            </app-audit-event-display>

            @if (!events.length) {
              <div class="text-sm text-slate-500 dark:text-slate-400 text-center py-4">Nenhum evento recente.</div>
            }
          </div>
        </div>
      }
    </div>
  </section>

  <section class="home-overview-section order-1 fhd:order-2 min-w-0 w-full fhd:sticky fhd:top-3 fhd:max-w-[min(1400px,calc(100vw-88px))]">
    <app-overview-hub></app-overview-hub>
  </section>
</div>
